 <!--降雨预报-->
<template>
    <div class="rainImg">
         <!-- <el-radio v-model="radio" label="1">湖南省</el-radio> -->
        <el-radio v-model="radio" label="0">全国</el-radio>
            <div class="aimg" >
            <a @click="tm1 =true;tm2 =false;tm3 =false" v-bind:style="{color:tm1?'#2d8cf0':'#000'}">24小时预报</a>
            <a @click="tm1 =false;tm2 =true;tm3 =false" v-bind:style="{color:tm2?'#2d8cf0':'#000'}">48小时预报</a>
            <a @click="tm1 =false;tm2 =false;tm3 =true" v-bind:style="{color:tm3?'#2d8cf0':'#000'}">72小时预报</a>
        </div>
        <el-row v-show="tm1">
            <el-col :span="24">
                <!-- <img src="http://218.77.42.151:8098/wxytload/ztev-iso/last24Precipitation.jpg" v-show="radio==0"/> -->
                <!-- <img src="http://10.43.15.16/cfrddss-pic/ztev-iso/last24Precipitation.jpg" v-show="radio==0"/> -->
                <img  v-bind:src="src24" v-show="radio==0"/>
            </el-col>
        </el-row>
         <el-row v-show="tm2">
            <el-col :span="24">
                <!-- <img src="http://218.77.42.151:8098/wxytload/ztev-iso/last48Precipitation.jpg" v-show="radio==0"/> -->
                <!-- <img src="http://10.43.15.16/cfrddss-pic/ztev-iso/last48Precipitation.jpg" v-show="radio==0"/> -->
                <img  v-bind:src="src48" v-show="radio==0"/>
             </el-col>
        </el-row>
         <el-row v-show="tm3">
            <el-col :span="24">
                <!-- <img src="http://218.77.42.151:8098/wxytload/ztev-iso/last72Precipitation.jpg" v-show="radio==0"/> -->
                <!-- <img src="http://10.43.15.16/cfrddss-pic/ztev-iso/last72Precipitation.jpg" v-show="radio==0"/> -->
                <img  v-bind:src="src72" v-show="radio==0"/>
             </el-col>
        </el-row>
    </div>
</template>
<script>
import moment from 'moment';
import axios from "axios";
import $ from "jquery";
export default {
  name: "rainImg",
 
  data() {
    return {
         tm1:true,
         tm2:false,  
         tm3:false,  
         src24:'',
         src48:'',
         src72:'',
         radio:"0",
    };
  },
 
  methods: {

    // 获取token
    async getSaasToken() {
        // 项目服务获取token接口
        let url = "http://223.151.53.94:9001/api/saas/getToken";
        await axios.get(url).then(async (res) => {
            if (res.data && res.data.host && res.data.token) {
            this.host = res.data.host;
            this.token = res.data.token;
            localStorage.setItem("saas-host", this.host);
            localStorage.setItem("saas-token", this.token);
            }
        });
    },
    // 获取图片列表
    async getImageList(isInvalid) {
    this.host = localStorage.getItem("saas-host")
        ? localStorage.getItem("saas-host")
        : "";
    this.token = localStorage.getItem("saas-token")
        ? localStorage.getItem("saas-token")
        : "";
    if (this.host.length === 0 || this.token.length === 0) {
        await this.getSaasToken();
    }

    // SaaS云平台OpenAPI服务气象接口
    let url = this.host + "/api/wth/image/listWthImg";
    let params = {
        configCode: "1dayPrecipitation",
        limitSize: 20,
    };
    let headers = {
        headers: {
        "Content-Type": "application/json",
        "Token-Cloud": this.token,
        },
    };
    axios.post(url, params, headers).then(async (res) => {
        if (res.data) {
        if (res.data.code === "0") {
            let data = res.data.data || [];
            if (data.length) {
            //   this.curImageUrl = data[0].webPath;
            this.src24 =  data[0].webPath
            this.src48 =  data[1].webPath
            this.src72 =  data[2].webPath
            }
        } else if (res.data.code === "100401") {
            // 默认请求认证失败时，清除无效token并自动发送请求
            if (!isInvalid) {
            // 清除无效token
            localStorage.removeItem("saas-host");
            localStorage.removeItem("saas-token");
            // 自动发送请求
            this.getImageList(true);
            }
        }
        }
    });
    },

    },
  mounted() {
    this.getImageList();
      console.log(window.innerHeight)
        // $(".rainImg").height(window.innerHeight-140-35-20);
        // $(".rainImg img").height($(".rainImg").height()-35);
        var ttDate= moment(new Date()).format("YYYY-MM-DD");
        var ttDate1= moment(new Date()).add(1, 'days').format("YYYY-MM-DD");
        var ttDate2= moment(new Date()).add(2, 'days').format("YYYY-MM-DD");
        ttDate = ttDate.replace(/[^0-9]/mg, '').match(/.{8}/); 
        ttDate1 = ttDate1.replace(/[^0-9]/mg, '').match(/.{8}/); 
        ttDate2 = ttDate2.replace(/[^0-9]/mg, '').match(/.{8}/);
        // if(ttDate[0].substring(4,5)!=0){
        // if(ttDate[0].substring(6,7)!=0){
        //     this.src24='http://113.247.231.116:10131/hunanDocument/24hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(4,6)+"/"+ttDate[0].substring(6,8)+"/"+ttDate.input+'0800_18.png'
        //     this.src48='http://113.247.231.116:10131/hunanDocument/48hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(4,6)+"/"+ttDate[0].substring(6,8)+"/"+ttDate1.input+'0800_19.png'
        //     this.src72='http://113.247.231.116:10131/hunanDocument/72hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(4,6)+"/"+ttDate[0].substring(6,8)+"/"+ttDate2.input+'0800_20.png'
        // }else{
        //     this.src24='http://113.247.231.116:10131/hunanDocument/24hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(4,6)+"/"+ttDate[0].substring(7,8)+"/"+ttDate.input+'0800_18.png'
        //     this.src48='http://113.247.231.116:10131/hunanDocument/48hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(4,6)+"/"+ttDate[0].substring(7,8)+"/"+ttDate1.input+'0800_19.png'
        //     this.src72='http://113.247.231.116:10131/hunanDocument/72hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(4,6)+"/"+ttDate[0].substring(7,8)+"/"+ttDate2.input+'0800_20.png'
        // }
        // }else{
        // if(ttDate[0].substring(6,7)!=0){
        //     this.src24='http://113.247.231.116:10131/hunanDocument/24hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(5,6)+"/"+ttDate[0].substring(6,8)+"/"+ttDate.input+'0800_18.png'
        //     this.src48='http://113.247.231.116:10131/hunanDocument/48hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(5,6)+"/"+ttDate[0].substring(6,8)+"/"+ttDate1.input+'0800_19.png'
        //     this.src72='http://113.247.231.116:10131/hunanDocument/72hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(5,6)+"/"+ttDate[0].substring(6,8)+"/"+ttDate2.input+'0800_20.png'
        // }else{
        //     this.src24='http://113.247.231.116:10131/hunanDocument/24hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(5,6)+"/"+ttDate[0].substring(7,8)+"/"+ttDate.input+'0800_18.png'
        //     this.src48='http://113.247.231.116:10131/hunanDocument/48hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(5,6)+"/"+ttDate[0].substring(7,8)+"/"+ttDate1.input+'0800_19.png'
        //     this.src72='http://113.247.231.116:10131/hunanDocument/72hForecastsMap/hunan/'+ttDate[0].substring(0,4)+"/"+ttDate[0].substring(5,6)+"/"+ttDate[0].substring(7,8)+"/"+ttDate2.input+'0800_20.png'
        // } 
        // }
 
  },
  components: {
  }
};
</script>
<style scoped lang="less">
.rainImg{
    width:100%;
    margin:0 auto;
}
.aimg{
    height: 30px;
    line-height: 30px;
    float: left;
    margin-left: 20px;
}
.rainImg .el-select,.rainImg .el-row{
    width: 100%;
    text-align: center;
    float: left;
}
.rainImg .el-radio{
    float: left; 
    height: 30px;
    line-height: 30px;
}
.rainImg img{
    max-width: 99%;
    padding-top:128px ;
}
.aimg a{
    margin-right:20px;
    cursor:pointer
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/jyyb.vue